import { deleteNotifications } from '../../api';
import { NotificationsName } from '../name';
import { removeNotifications } from '../@sync/remove';
import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createDeleteAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const notificationsDeleteSlice = createDeleteAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.NOTIFICATIONS_CLEARED),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		preRequestActionCreators: [ removeNotifications.syncActionCreator ]
	},
	name: NotificationsName,
	receive: false,
	request: false,
	requestHandler: deleteNotifications
});
